export const allowFiles = ['image/png', 'image/jpg', 'image/jpeg', 'image/webp'];
export const onlyPng = ['application/pdf'];

export const throwImageFiltering = (files: FileList, isPdf?: boolean) => {
  const filteredFiles = Array.from(files)
    .filter((file) => {
      if (!(isPdf ? onlyPng : allowFiles).includes(file.type)) {
        return false
      }

      if (file.size <= 10 * 1024 * 1024) {
        return true
      }

      return false
    }); // 10MB in bytes

  const newDataTransfer = new DataTransfer();

  filteredFiles.forEach((file) => {
    newDataTransfer.items.add(file);
  });

  return newDataTransfer.files;
}
